<div class="fo-container">
  <mat-card class="fo-card">
    <div class="fo-card-content">
      <mat-icon class="fo-icon success">check_circle</mat-icon>
      <h2>Account Connected</h2>
      <p class="fo-description">
        Your CNH FieldOps account has been successfully connected. Your field operation data will now be automatically synced to Precision Gateway.
      </p>

      <button mat-raised-button color="primary" class="fo-button" routerLink="/mapping">
        <mat-icon>map</mat-icon>
        <span>Back to Map</span>
      </button>
    </div>
  </mat-card>
</div>
